import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import work1 from '../Assets/Work_Images/work1.jpg';
import EnvelopeSim from './EnvelopeSim';

const systems = {
    overview: {
        eyebrow: 'Architectural envelope',
        title: 'A complete facade, system by system',
        text: 'The model brings together the work we design, fabricate and install: glazing, cladding, doors and windows, clean rooms, railing, canopies and skylights.',
        quote: 'Aluminium profiles with a double-glazed system.',
        items: [],
    },
    glazing: {
        eyebrow: '01 · Glazing',
        title: 'Glazing',
        text: 'Curtain wall and spider glazing, from unitised systems to tension cable and rod fittings.',
        quote: 'Light, strength and style',
        items: ['Unitised Glazing', 'Semi Unitised Glazing', 'Toggle Glazing', 'Spider Glazing', 'Curtain Wall', 'Tension Cable / Rod Glazing'],
    },
    cladding: {
        eyebrow: '02 · Cladding',
        title: 'Cladding',
        text: 'Exterior skins in aluminium panels and other architectural finishes.',
        quote: 'Durable architectural skins',
        items: ['Aluminium Cladding Panels', 'High-Pressure Laminate', 'Terracotta Tiles', 'Zinc', 'Porcelain Tiles', 'Solid Aluminium'],
    },
    doors: {
        eyebrow: '03 · Doors & Windows',
        title: 'Doors & Windows',
        text: 'Aluminium and UPVC windows and doors, from slimline and casement to lift-and-slide.',
        quote: 'Durable elegance',
        items: ['Sliding Windows with inbuilt railing', 'Slimline Windows', 'Casement Windows', 'Ventilators', 'Lift and Slide', 'Fixed Doors and Windows', 'Patch Fixed', 'Auto Sliding Door'],
    },
    cleanroom: {
        eyebrow: '04 · Clean rooms',
        title: 'Clean room systems',
        text: 'Flush partitions, walkable ceilings, and controlled interiors.',
        quote: 'Controlled, precise interiors',
        items: ['Flush Door / Window', 'Walkable & Non Walkable Ceiling', 'Clean Room Partitions', 'Walk on Ceilings', 'OT Room Solutions', 'Fire Rated / Emergency Exit Doors'],
    },
    railing: {
        eyebrow: '05 · Railing',
        title: 'Railing',
        text: 'Stainless steel, mild steel, and free-standing railing.',
        quote: 'Safety meets finish',
        items: ['SS Railing', 'MS Railing', 'Free Standing Railing'],
    },
    canopy: {
        eyebrow: '06 · Canopies & Skylights',
        title: 'Canopies & Skylights',
        text: 'Spider canopies and aluminium-framed skylights for the entrance and the roof.',
        quote: 'Welcoming light and cover',
        items: ['Spider Canopies', 'Curtain Wall Canopies', 'Aluminium Framed Skylights', 'Spider Fitted Skylights'],
    },
};

const AboutSection = ({ compact = false }) => {
    const [systemId, setSystemId] = useState('overview');
    const system = systems[systemId] || systems.overview;

    return (
        <section className="page-section" id="aboutus">
            <div className="container">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6 reveal">
                        {compact ? (
                            <EnvelopeSim onChange={setSystemId} />
                        ) : (
                            <div className="about-photo-frame">
                                <img src={work1} alt="Sona Alusys facade work" className="about-photo" />
                            </div>
                        )}
                    </div>
                    <div className="col-lg-6 reveal reveal-delay">
                        {compact ? (
                            <div className="envelope-copy" aria-live="polite">
                                <p className="eyebrow">{system.eyebrow}</p>
                                <h2 className="section-title">{system.title}</h2>
                                <p>{system.text}</p>
                                <p className="about-quote">{system.quote}</p>
                                {system.items.length > 0 && (
                                    <ul className="envelope-points">
                                        {system.items.map((item) => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                <Link className="btn-line" to="/services">View services</Link>
                            </div>
                        ) : (
                            <>
                                <p className="eyebrow">About us</p>
                                <h2 className="section-title">Facade engineering with a precise finish</h2>
                                <p>
                                    Established in 2025, Sona Alusys Industries fabricates and installs glass, aluminium and UPVC work for facades, glazing, doors and windows.
                                </p>
                                <p className="about-quote">Our experience and expertise in UPVC and aluminium fabrication.</p>
                                <p>
                                    The head office is in Ghaziabad, Uttar Pradesh, and the factory is at Dasna, Hapur.
                                </p>
                                <p>
                                    The work covers commercial, residential, hospitality, industrial and IT buildings.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
